import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Link from '../Link';
export default styled(Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  background-color: ", ";\n  color: ", ";\n  padding: 1rem;\n\n  &:focus,\n  &:hover {\n    color: ", ";\n  }\n\n  z-index: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.actionableHover;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.contentReverse;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.contentReverse;
}, function (props) {
  return props.theme.zIndex.dropdown;
});
//# sourceMappingURL=styles.js.map